import React from "react";
import { trackEvent } from "../analytics";
import MantleWaves from "./MantleWaves";
import ParticleField from "./ParticleField";

const stats = [
  { label: "15+ Years", detail: "Engineering Experience" },
  { label: "Java · Spring · React", detail: "Core Stack" },
  { label: "UK-Based", detail: "Cambridge, UK" },
];

export default function About() {
  return (
    <section id="about" className="bg-purple-900 text-white relative overflow-hidden">
      <div
        className="absolute -top-32 -left-32 w-96 h-96 rounded-full bg-purple-600 opacity-30 blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <div
        className="absolute -bottom-40 -right-20 w-96 h-96 rounded-full bg-fuchsia-600 opacity-20 blur-3xl pointer-events-none"
        aria-hidden="true"
      />
      <MantleWaves className="h-48 md:h-64" />
      <ParticleField className="absolute inset-0" />
      <div className="container mx-auto flex flex-col items-center text-center px-5 py-20 md:py-28 relative">
        <h1 className="animate-pop-in-glow title-font font-bold text-4xl sm:text-5xl lg:text-6xl mb-6 text-white max-w-4xl">
          Expert Engineering.
          <br />
          Modern Software.
          <br />
          Real Business Outcomes.
        </h1>
        <p
          className="animate-pop-in mb-4 leading-relaxed text-lg sm:text-xl max-w-2xl"
          style={{ animationDelay: "0.15s" }}
        >
          We help financial services companies, SMEs and founders design,
          build and modernise software.
        </p>
        <p
          className="animate-pop-in mb-8 leading-relaxed text-base text-purple-200 max-w-2xl"
          style={{ animationDelay: "0.3s" }}
        >
          15+ years of engineering experience across financial services,
          distributed systems and cloud-native platforms: Java, Spring
          Boot, Kafka, Kubernetes, React and AI. From modernising legacy
          platforms to shipping new products, we bring senior-level
          engineering to teams that can't yet hire it full-time.
        </p>

        <div
          className="animate-pop-in flex justify-center flex-wrap gap-2 mb-8"
          style={{ animationDelay: "0.45s" }}
        >
          {[
            "Technology Consultancy",
            "Product & SaaS",
            "AI & Automation",
            "Financial Services",
          ].map((pill) => (
            <span
              key={pill}
              className="text-xs sm:text-sm bg-purple-800 border border-purple-700 text-purple-100 rounded-full px-3 py-1"
            >
              {pill}
            </span>
          ))}
        </div>

        <div
          className="animate-pop-in flex justify-center flex-wrap gap-4 mb-14"
          style={{ animationDelay: "0.6s" }}
        >
          <a
            href="#contact"
            onClick={() => trackEvent("cta_click", { location: "hero" })}
            className="inline-flex text-white bg-purple-500 border-0 py-2 px-6 focus:outline-none hover:bg-purple-400 rounded-full text-lg font-medium"
          >
            Work With Us
          </a>
          <a
            href="#projects"
            className="inline-flex text-white bg-purple-800 border border-purple-700 py-2 px-6 focus:outline-none hover:bg-purple-700 rounded-full text-lg"
          >
            View Our Work
          </a>
        </div>

        <div
          className="animate-pop-in grid grid-cols-1 sm:grid-cols-3 gap-4 w-full max-w-2xl mb-14"
          style={{ animationDelay: "0.75s" }}
        >
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-purple-800 border border-purple-700 rounded-xl px-4 py-3"
            >
              <p className="font-bold title-font">{stat.label}</p>
              <p className="text-purple-300 text-xs mt-1">{stat.detail}</p>
            </div>
          ))}
        </div>

        <img
          className="animate-pop-in object-cover object-center rounded-2xl w-full max-w-xl h-auto"
          style={{ animationDelay: "0.9s" }}
          alt="hero"
          src="/coding.svg"
        />
      </div>
    </section>
  );
}
